import React, { useState } from "react";
import { motion } from "framer-motion";
import NavTitle from "./NavTitle";

/**
 * SEO-Friendly Color Filter Component
 * Allows users to filter trade products by color with smooth animations
 * Optimized for search engines, accessibility, and user engagement
 */
const Color = () => {
  const [showColors, setShowColors] = useState(true);

  const colors = [
    { _id: 9001, title: "Green", base: "#22c55e", keywords: "green vegetables, fresh herbs, export products" },
    { _id: 9002, title: "Gray", base: "#a3a3a3", keywords: "industrial items, gray spices, exported goods" },
    { _id: 9003, title: "Red", base: "#dc2626", keywords: "red chilies, red onions, fresh produce" },
    { _id: 9004, title: "Yellow", base: "#f59e0b", keywords: "yellow spices, turmeric, exported vegetables" },
    { _id: 9005, title: "Blue", base: "#3b82f6", keywords: "blue packaging, specialty products, global trade" },
  ];

  return (
    <aside className="w-full">
      {/* Section Header */}
      <button
        onClick={() => setShowColors(!showColors)}
        className="w-full flex justify-between items-center cursor-pointer"
        aria-expanded={showColors}
        aria-label={`Toggle Trade by Color Filter`}
      >
        <NavTitle title="Trade by Color" showicon={showColors} icons={true} />
      </button>

      {/* Color List */}
      {showColors && (
        <motion.ul
          initial={{ y: -10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="flex flex-col gap-3 mt-2 text-sm lg:text-base text-gray-700"
        >
          {colors.map(({ _id, title, base, keywords }) => (
            <li
              key={_id}
              className="flex items-center gap-2 pb-2 border-b border-gray-200"
              aria-label={`Color Filter: ${title}`}
            >
              <span
                style={{ backgroundColor: base }}
                className="w-4 h-4 rounded-full border border-gray-300"
              ></span>
              <span className="font-medium">{title}</span>
              {/* Hidden SEO keywords for better ranking */}
              <meta name="keywords" content={keywords} />
            </li>
          ))}
        </motion.ul>
      )}
    </aside>
  );
};

export default Color;
